export default function truncate(value, maxlength, separator) {
  separator = separator || "...";
  const finalLength = maxlength - separator.length;
  const front = Math.ceil(finalLength / 2);
  const back = Math.floor(finalLength / 2);
  return value.length > maxlength
    ? value.substr(0, front) + "..." + value.substr(value.length - back)
    : value;
}
